export default {
  // 航班节点
  earlyDeparture: '提前起飞',
  lateStandby: '晚站',
  takeoff: '起飞',
  landing: '落地',
  parking: '泊位',
  doorOpen: '开舱门',
  khorgosClearance: '霍尔果斯转关',
  kazakhstanClearance: '哈萨克斯坦转关',
  cargoArriveALA: '货物抵达ALA货站',
  cargoWarehouseIn: '货物入库',
  palletComplete: '组板完成',
  weighingSlip: '出磅单',
  cargoWarehouseOut: '货物出库',
  sendToApron: '送到机坪',
  crewHotelDepart: '装载机组酒店出发',
  loadingCrewAirportArrive: '装机机组机场到达',
  loadingCrewToPlane: '装机机组到机下',
  flightCrewHotelDepart: '飞行机组酒店出发',
  flightCrewAirportArrive: '飞行机组机场到达',
  flightCrewBoarding: '飞行机组登机',
  loadingStart: '开始装机',
  loadingEnd: '结束装机',
  doorCloseRelease: '关门放行',
  pushback: '推出',
  departure: '起飞',
  diversion: '备降',
  
  // 节点状态
  completed: '已完成',
  pending: '待完成',
  inProgress: '进行中',
  delayed: '延误',
  abnormal: '异常',
  
  // 操作
  markComplete: '标记完成',
  reportAbnormal: '报告异常',
  viewDetails: '查看详情',
  updateProgress: '更新进度',
};